import { render } from "./VizioThree.vue?vue&type=template&id=45b095d9"
import script from "./VizioThree.vue?vue&type=script&lang=js"
export * from "./VizioThree.vue?vue&type=script&lang=js"

import "./VizioThree.vue?vue&type=style&index=0&id=45b095d9&lang=css"
script.render = render

export default script